import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'widgets';
export const actionTypes = {
  FETCH_WIDGET_DATA: `${FEATURE_NAME}/FETCH_WIDGET_DATA`,
  FETCH_WIDGETS: `${FEATURE_NAME}/FETCH_WIDGETS`,
  CREATE_WIDGET: `${FEATURE_NAME}/CREATE_WIDGET`,
  UPDATE_WIDGET: `${FEATURE_NAME}/UPDATE_WIDGET`,
  DELETE_WIDGET: `${FEATURE_NAME}/DELETE_WIDGET`,
  DUPLICATE_WIDGET: `${FEATURE_NAME}/DUPLICATE_WIDGET`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
